<mat-toolbar class="main-header justify-content-between">
  <img src="../../../../assets/images/app-temp-logo.png" height="50" style="padding: 5px" />
  <div class="d-flex align-items-center">

    <button class="common-button blue mat-elevation-z0 me-3" [disabled]="!isKeyAutomateEnabled || !isPaid" mat-button
      mat-raised-button (click)="openRfidScannerDrawer()" *ngIf="isenableKeyCardScan">
      <span class="material-symbols-outlined me-2">
        cell_tower
      </span>Scan KEY Card</button>

    <button class="common-button blue mat-elevation-z0 me-3" [disabled]="!isKeyAutomateEnabled || !isPaid" *ngIf="isEnableQrScanning"
       mat-button mat-raised-button (click)="openScannerDrawer()">
      <span class="material-symbols-outlined me-2">
        qr_code_scanner
      </span>Scan QR</button>

    <button class="common-button blue mat-elevation-z0 me-3" [disabled]="!isKeyAutomateEnabled || !isPaid"
      (click)="openFeedbackDialog()" mat-button mat-raised-button>Submit Feedback</button>
    <app-user-profile-menu class="d-flex align-items-center  float-start"></app-user-profile-menu>
  </div>
</mat-toolbar>
